<template>
  <div>
    <b-overlay :show="loading" opacity="0.99">
      <div class="p-5 v-clean" v-if="group_prescription_cares.length == 0">
        <h6 class="text-center upper-text worksansr">Sem resultados!</h6>
      </div>

      <v-expansion-panels
        v-model="panel_group_prescription_care"
        hover
        multiple
        tile
        class="border border-for"
      >
        <v-expansion-panel
          v-for="(
            group_prescription_care, key_group
          ) in group_prescription_cares"
          :key="group_prescription_care.id"
        >
          <v-expansion-panel-header>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                <h6 class="mb-0 check-text-center">
                  RESIDENTE {{ group_prescription_care.resident_name }}
                </h6>
                <h6 class="mb-1 worksansr check-text-center">
                  VALIDADE:
                  {{ formatDate(group_prescription_care.start_date, false) }}
                  ATÉ
                  {{ formatDate(group_prescription_care.end_date, false) }}
                </h6>
                <h6
                  class="inline-display text-eleven mb-0 pt-1 pb-1 pl-2 pr-2 v-danger"
                  v-if="group_prescription_care.expired_prescription"
                >
                  PRESCRIÇÃO VENCIDA
                </h6>
              </div>
              <!-- PRESCRIÇÃO -->
              <div
                class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 d-flex align-items-center"
              >
                <img
                  v-if="
                    !group_prescription_care.finish_user ||
                    group_prescription_care.status == 'PENDENTE'
                  "
                  class="mr-2 no-user-photo-url"
                  :src="require('../../../assets/user.png')"
                />
                <img
                  v-if="
                    group_prescription_care.finish_user &&
                    group_prescription_care.status != 'INATIVO'
                  "
                  :class="[
                    'mr-2',
                    group_prescription_care.finish_user.photo_url
                      ? 'user-photo-url'
                      : 'no-user-photo-url',
                  ]"
                  :src="
                    group_prescription_care.finish_user.photo_url
                      ? group_prescription_care.finish_user.photo_url
                      : require('../../../assets/user.png')
                  "
                />
                <div>
                  <h6 class="legends mb-0">
                    PRESCRIÇÃO
                    <span
                      :class="[
                        handleClassStatusGroupPrescriptionCare(
                          group_prescription_care.status
                        ),
                      ]"
                    >
                      {{
                        {
                          PENDENTE: "PENDENTE",
                          CANCELADO: "CANCELADA",
                          FINALIZADO: "FINALIZADA",
                          INATIVO: "APAGADA",
                        }[group_prescription_care.status] || ""
                      }}
                    </span>
                    <span
                      v-if="
                        group_prescription_care.finish_user &&
                        group_prescription_care.status != 'INATIVO'
                      "
                    >
                      POR
                    </span>
                  </h6>
                  <h6
                    v-if="
                      group_prescription_care.finish_user &&
                      group_prescription_care.status != 'INATIVO'
                    "
                    class="legends worksansr mb-0"
                  >
                    {{
                      professionalClassCouncilValue({
                        id: group_prescription_care.finish_user
                          .professional_class_council_id,
                        name: group_prescription_care.finish_user.name,
                        value:
                          group_prescription_care.finish_user
                            .professional_class_council_value,
                        cpf: group_prescription_care.finish_user.cpf,
                        office: group_prescription_care.finish_user.office,
                      })
                    }}
                  </h6>
                </div>
              </div>
              <!-- APRAZAMENTO -->
              <div
                class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 d-flex align-items-center"
              >
                <img
                  v-if="
                    !group_prescription_care.user_finish_prescription_care_time ||
                    group_prescription_care.status_prescription_care_time ==
                      'PENDENTE'
                  "
                  class="mr-2 no-user-photo-url"
                  :src="require('../../../assets/user.png')"
                />
                <img
                  v-if="
                    group_prescription_care.user_finish_prescription_care_time &&
                    group_prescription_care.status_prescription_care_time !=
                      'INATIVO'
                  "
                  :class="[
                    'mr-2',
                    group_prescription_care.user_finish_prescription_care_time
                      .photo_url
                      ? 'user-photo-url'
                      : 'no-user-photo-url',
                  ]"
                  :src="
                    group_prescription_care.user_finish_prescription_care_time
                      .photo_url
                      ? group_prescription_care
                          .user_finish_prescription_care_time.photo_url
                      : require('../../../assets/user.png')
                  "
                />
                <div>
                  <h6 class="legends mb-0">
                    APRAZAMENTO
                    <span
                      :class="[
                        handleClassStatusGroupPrescriptionCare(
                          group_prescription_care.status_prescription_care_time
                        ),
                      ]"
                    >
                      {{
                        {
                          PENDENTE: "PENDENTE",
                          CANCELADO: "CANCELADO",
                          FINALIZADO: "FINALIZADO",
                          INATIVO: "APAGADO",
                        }[
                          group_prescription_care.status_prescription_care_time
                        ] || ""
                      }}
                    </span>
                    <span
                      v-if="
                        group_prescription_care.user_finish_prescription_care_time &&
                        group_prescription_care.status_prescription_care_time !=
                          'INATIVO'
                      "
                    >
                      POR
                    </span>
                  </h6>
                  <h6
                    v-if="
                      group_prescription_care.user_finish_prescription_care_time &&
                      group_prescription_care.status_prescription_care_time !=
                        'INATIVO'
                    "
                    class="legends worksansr mb-0"
                  >
                    {{
                      professionalClassCouncilValue({
                        id: group_prescription_care
                          .user_finish_prescription_care_time
                          .professional_class_council_id,
                        name: group_prescription_care
                          .user_finish_prescription_care_time.name,
                        value:
                          group_prescription_care
                            .user_finish_prescription_care_time
                            .professional_class_council_value,
                        cpf: group_prescription_care
                          .user_finish_prescription_care_time.cpf,
                        office:
                          group_prescription_care
                            .user_finish_prescription_care_time.office,
                      })
                    }}
                  </h6>
                </div>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="row">
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 check-text-left"
              >
                <v-btn
                  v-if="
                    permission('write', 'resident_medical_prescription') &&
                    group_prescription_care.issetPrescriptionCareTime &&
                    group_prescription_care.status != 'INATIVO'
                  "
                  @click="
                    handleModalDuplicateGroupPrescriptionCare(
                      group_prescription_care.id
                    )
                  "
                  class="btn-duplicate m-1"
                >
                  <i
                    :class="[
                      'fas fa-copy text-twenty',
                      width < 600 ? 'mr-0 ' : 'mr-2',
                    ]"
                  ></i>
                  <span v-if="width > 600">DUPLICAR</span>
                </v-btn>

                <v-btn
                  @click="handlePrint(group_prescription_care)"
                  class="btn-print m-1"
                >
                  <i
                    :class="[
                      'fas fa-print text-twenty',
                      width < 600 ? 'mr-0' : 'mr-2',
                    ]"
                  ></i>
                  <span v-if="width > 600">IMPRIMIR</span>
                </v-btn>
                <v-btn
                  v-if="
                    permission('edit', 'resident_medical_prescription') &&
                    group_prescription_care.status != 'CANCELADO' &&
                    group_prescription_care.status != 'INATIVO'
                  "
                  @click="
                    handleModalUpdateGroupPrescriptionCare(
                      group_prescription_care.id
                    )
                  "
                  class="btn-edit m-1"
                >
                  <i
                    :class="[
                      'fas fa-pencil-alt text-twenty',
                      width < 600 ? 'mr-0' : 'mr-2',
                    ]"
                  ></i>
                  <span v-if="width > 600">EDITAR</span>
                </v-btn>

                <v-btn
                  v-if="
                    permission('edit', 'resident_medical_prescription') &&
                    group_prescription_care.status != 'INATIVO' &&
                    group_prescription_care.status != 'CANCELADO'
                  "
                  @click="
                    handleModalDeleteGroupPrescriptionCare(
                      group_prescription_care.id
                    )
                  "
                  class="btn-delete m-1"
                >
                  <i
                    :class="[
                      'fas fa-trash text-twenty',
                      width < 600 ? 'mr-0' : 'mr-2',
                    ]"
                  >
                  </i>
                  <span v-if="width > 600">EXCLUIR</span>
                </v-btn>

                <b-modal
                  size="xl"
                  no-close-on-backdrop
                  hide-footer
                  :id="`history_prescription_${group_prescription_care.id}`"
                  title="HISTÓRICO"
                >
                  <History
                    show_text_no_data
                    entity_id_disabled
                    user_id_disabled
                    :entity_id="group_prescription_care.id"
                    table="group_prescription_care"
                    :toggle="open_history_prescription"
                  />
                </b-modal>

                <v-btn
                  class="btn-dateils ml-2"
                  @click="
                    handleModalHistoryPrescription(group_prescription_care.id)
                  "
                >
                  <i class="fas fa-history mr-1 mr-2 text-twenty"></i> HISTÓRICO
                </v-btn>

                <b-modal
                  size="lg"
                  no-close-on-backdrop
                  hide-footer
                  :id="`attachments_prescription_${group_prescription_care.id}`"
                  title="ANEXOS"
                >
                  <Attachments
                    :group_prescription_care_id="group_prescription_care.id"
                  />
                </b-modal>

                <v-btn
                  v-if="permission('write', 'resident_medical_prescription')"
                  class="v-success ml-2"
                  @click="
                    handleModalAttachmentsPrescription(
                      group_prescription_care.id
                    )
                  "
                >
                  <i class="fas fa-folder mr-1 mr-2 text-twenty"></i> ANEXOS
                </v-btn>

                <b-modal
                  size="lg"
                  no-close-on-backdrop
                  hide-footer
                  :id="`general_information_prescription_care${group_prescription_care.id}`"
                  title="INFORMAÇÕES GERAIS CUIDADOS"
                >
                  <GeneralInformationCare
                    :group_prescription_care_id="group_prescription_care.id"
                  />
                </b-modal>

                <v-btn
                  class="btn-edit ml-2"
                  @click="
                    handleModalGeneralInformation(group_prescription_care.id)
                  "
                >
                  <i class="fas fa-edit mr-1 mr-2 text-twenty"></i>
                  INFORMAÇÕES GERAIS
                </v-btn>
              </div>

              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 check-text-right"
              >
                <v-btn
                  v-if="
                    permission('edit', 'resident_medical_prescription') &&
                    group_prescription_care.status != 'INATIVO' &&
                    group_prescription_care.status != 'CANCELADO'
                  "
                  @click="
                    handleModalAddPrescriptionCare(
                      group_prescription_care,
                      key_group
                    )
                  "
                  class="btn-two-add m-1"
                >
                  <i class="fas fa-plus mr-2 text-twenty"></i>

                  ADICIONAR CUIDADOS
                </v-btn>

                <v-btn
                  v-if="
                    permission('edit', 'resident_medical_prescription') &&
                    group_prescription_care.issetPrescriptionCareTime &&
                    group_prescription_care.status == 'PENDENTE'
                  "
                  @click="
                    handleModalFinishGroupPrescriptionCare(
                      group_prescription_care.id
                    )
                  "
                  class="btn-save m-1"
                >
                  <i class="fas fa-check mr-2 text-twenty"></i>FINALIZAR
                </v-btn>
                <ButtonGenerateCertificate
                  v-if="group_prescription_care.data_base64"
                  :id="group_prescription_care.id"
                  :data_base64="group_prescription_care.data_base64"
                />
              </div>

              <b-modal
                size="md"
                no-close-on-backdrop
                hide-footer
                :id="`modalDuplicateGroupPrescriptionCare_${group_prescription_care.id}`"
                title="DUPLICAR PRESCRIÇÃO DE CUIDADO"
              >
                <GroupCareDuplicate
                  :id="group_prescription_care.id"
                  :resident_name="group_prescription_care.resident_name"
                  v-on:duplicate="
                    handleDuplicateGroupPrescriptionCare(
                      group_prescription_care.id
                    )
                  "
                />
              </b-modal>

              <b-modal
                size="md"
                no-close-on-backdrop
                hide-footer
                :id="`modalUpdateGroupPrescriptionCare_${group_prescription_care.id}`"
                title="EDITAR PRESCRIÇÃO DE CUIDADOS"
              >
                <GroupCareView
                  :id="group_prescription_care.id"
                  :resident_name="group_prescription_care.resident_name"
                  :start_date="group_prescription_care.start_date"
                  :end_date="group_prescription_care.end_date"
                  :resident_id="resident_id"
                  v-on:update="
                    handleUpdateGroupPrescriptionCare(
                      group_prescription_care.id,
                      key_group
                    )
                  "
                  v-on:cancel="
                    $bvModal.hide(
                      `modalUpdateGroupPrescriptionCare_${group_prescription_care.id}`
                    )
                  "
                />
              </b-modal>

              <b-modal
                size="md"
                no-close-on-backdrop
                hide-footer
                :id="`modalFinishGroupPrescriptionCare_${group_prescription_care.id}`"
                title="FINALIZAR"
              >
                <GroupCareFinish
                  :id="group_prescription_care.id"
                  :start_date="group_prescription_care.start_date"
                  :end_date="group_prescription_care.end_date"
                  v-on:finish="
                    handleFinishGroupPrescriptionCare(
                      group_prescription_care.id
                    )
                  "
                />
              </b-modal>

              <b-modal
                size="md"
                no-close-on-backdrop
                hide-footer
                :id="`modalDeleteGroupPrescriptionCare_${group_prescription_care.id}`"
                title="EXCLUIR PRESCRIÇÃO"
              >
                <GroupCareDelete
                  :id="group_prescription_care.id"
                  v-on:delete="
                    handleDeleteGroupPrescriptionCare(
                      group_prescription_care.id
                    )
                  "
                />
              </b-modal>

              <div class="col-md-12">
                <confirmation-dialog
                  validate
                  v-if="
                    group_prescription_care.status == 'FINALIZADO' &&
                    group_prescription_care.technical_responsible == 0 &&
                    userIsTechnicalResponsible
                  "
                  header-class=""
                  message-title="VALIDAR PRESCRIÇÃO"
                  message-body="Deseja realmente Validar essa evolução?"
                  open-class="btn-modern btn-modern-save"
                  open-left-icon="fas fa-check"
                  open-text="VALIDAR PRESCRIÇÃO"
                  @yes="validatePrescription(group_prescription_care.id)"
                />
              </div>

              <div class="col-md-12">
                <LinkVerLocalizacaoRegistro :item="group_prescription_care" />
              </div>

              <!-- Lista de itens -->
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <v-expansion-panels
                  v-model="panel_prescription_care"
                  hover
                  multiple
                  tile
                >
                  <v-expansion-panel
                    v-for="(
                      item, key_care
                    ) in group_prescription_care.prescription_cares"
                    :key="key_care"
                  >
                    <v-expansion-panel-header class="medidine">
                      <div class="row">
                        <div
                          class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-12 d-flex justify-content-center align-items-center"
                        >
                          <i
                            class="fas fa-hand-holding-heart fa-2x color-blue"
                          ></i>
                        </div>

                        <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12">
                          <!-- PEGAR O NOME DA CARE -->
                          <h6 class="mb-0 color-black check-text-center">
                            {{ item.care_name }}
                          </h6>

                          <h6
                            class="color-deleted text-thirteen check-text-center"
                            v-if="item.prescription_care_status == 'EXCLUIDO'"
                          >
                            CUIDADO EXCLUIDO NO DIA
                            {{ formatDate(item.updated_at, false) }}.

                            <br />

                            <span>
                              NÃO IRÁ APARECER NA PRESCRIÇÃO A PARTIR DO DIA
                              {{ formatDate(item.end, false) }}!</span
                            >
                          </h6>

                          <h6
                            class="color-edit text-thirteen check-text-center"
                            v-if="item.edited == 1"
                          >
                            CUIDADO EDITADO NO DIA
                            {{ formatDate(item.edited_date, false) }}.

                            <br />

                            <span class="color-deleted">
                              NÃO IRÁ APARECER NA PRESCRIÇÃO A PARTIR DO DIA
                              {{ formatDate(item.end, false) }}!
                            </span>
                          </h6>
                        </div>

                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 d-flex check-justifique-right align-items-center pr-5"
                        >
                          <div>
                            <h6 class="mb-0 check-text-right">
                              {{ item.care_amount_of_times_name }}
                            </h6>

                            <h6 class="mb-0 worksansr check-text-right">
                              {{ handleDuration(item.duration) }}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <div class="row mt-3">
                        <div
                          class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12"
                        >
                          <p class="mb-0 worksansr legends">
                            Frequência:
                            {{ handleFrequency(item.frequency) }}
                          </p>

                          <p
                            class="mb-0 worksansr legends"
                            v-if="item.frequency != 'EVENTUAL'"
                          >
                            Repetição:
                            {{ handleEvery(item.every, item.frequency) }}
                          </p>

                          <p
                            class="mb-0 worksansr legends"
                            v-if="item.frequency == 'SEMANAL'"
                          >
                            Dias da semana:
                            {{ item.dom && "DOM" }}
                            {{ item.seg && "SEG" }}
                            {{ item.ter && "TER" }}
                            {{ item.qua && "QUA" }}
                            {{ item.qui && "QUI" }}
                            {{ item.sex && "SEX" }}
                            {{ item.sab && "SAB" }}
                          </p>

                          <p
                            class="mb-0 worksansr legends"
                            v-if="item.care_amount_of_times_name"
                          >
                            Quantidade diária:
                            {{ item.care_amount_of_times_name }}
                          </p>

                          <div
                            class="col-xl-4 col-lg-7 col-md-12 col-sm-12 col-12 v-clean mt-1 mb-1 p-1"
                            v-if="item.care_amount_of_times_type == 'SHIFTS'"
                          >
                            <div class="row">
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pt-0 pb-0"
                              >
                                <h6 class="mb-0">TURNO</h6>
                              </div>

                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pt-0 pb-0 pl-0"
                              >
                                <h6 class="mb-0">QUANTIDADE</h6>
                              </div>
                            </div>

                            <div class="row" v-if="item.dawn">
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="mb-0 worksansr legends">
                                  MADRUGADA
                                </h6>
                              </div>
                            </div>

                            <div class="row" v-if="item.morning">
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="mb-0 worksansr legends">MANHÃ</h6>
                              </div>
                            </div>

                            <div class="row" v-if="item.afternoon">
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="mb-0 worksansr legends">TARDE</h6>
                              </div>
                            </div>

                            <div class="row" v-if="item.night">
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="worksansr mb-0 legends">NOITE</h6>
                              </div>
                            </div>

                            <div
                              class="row"
                              v-if="item.shift_5 && item.shift_5_quantity"
                            >
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="worksansr mb-0 legends">5º</h6>
                              </div>
                            </div>

                            <div class="row" v-if="item.shift_6">
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="worksansr mb-0 legends">6º</h6>
                              </div>
                            </div>

                            <div class="row" v-if="item.shift_7">
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="worksansr mb-0 legends">7º</h6>
                              </div>
                            </div>

                            <div class="row" v-if="item.shift_8">
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="worksansr mb-0 legends">8º</h6>
                              </div>
                            </div>
                          </div>

                          <p
                            class="mb-0 worksansr legends"
                            v-if="
                              item.frequency != 'EVENTUAL' &&
                              (item.duration == 'ATE_A_DATA' ||
                                item.duration == 'DURANTE_UM_PERIODO')
                            "
                          >
                            Data de início:
                            {{ formatDate(item.start_date, false) }}
                          </p>

                          <p
                            class="mb-0 worksansr legends"
                            v-if="item.frequency != 'EVENTUAL'"
                          >
                            Duração:
                            {{ handleDuration(item.duration) }}
                          </p>

                          <p
                            class="mb-0 worksansr legends"
                            v-if="
                              item.frequency != 'EVENTUAL' &&
                              item.duration == 'DURANTE_UM_PERIODO'
                            "
                          >
                            Período de:
                            {{ item.duration_time }} dia(s)
                          </p>

                          <p
                            class="mb-0 worksansr legends"
                            v-if="
                              item.frequency != 'EVENTUAL' &&
                              item.duration == 'ATE_A_DATA'
                            "
                          >
                            Data de término:
                            {{ formatDate(item.end_date, false) }}
                          </p>

                          <p
                            class="mb-0 worksansr legends"
                            v-if="item.instruction"
                          >
                            Instrução:
                            {{ item.instruction }}
                          </p>

                          <h6 class="mt-2 legends">
                            CUIDADO CADASTRADO POR:
                            {{ item.user_name }}
                          </h6>

                          <p class="mt-0 mb-0" v-if="item.init">
                            Cuidado inicia:
                            {{ formatDate(item.init, false) }}
                          </p>

                          <p
                            class="mt-0 mb-0"
                            v-if="
                              item.prescription_care_status == 'EXCLUIDO' &&
                              item.end_care
                            "
                          >
                            Cuidado termina:
                            {{ formatDate(item.end_care, false) }}
                          </p>

                          <p
                            class="mt-0 mb-0"
                            v-if="item.edited == 1 && item.end_care"
                          >
                            Cuidado termina:
                            {{ formatDate(item.end_care, false) }}
                          </p>

                          <p class="mt-2">
                            Cadastrado: {{ formatDate(item.created_at, false) }}

                            <br />

                            Última alteração:
                            {{ formatDate(item.updated_at, false) }}
                          </p>

                          <b-modal
                            size="xl"
                            no-close-on-backdrop
                            hide-footer
                            :id="`history_care_${item.id}`"
                            title="HISTÓRICO"
                          >
                            <History
                              show_text_no_data
                              entity_id_disabled
                              user_id_disabled
                              :entity_id="item.id"
                              table="prescription_care"
                              :toggle="open_history_care"
                            />
                          </b-modal>

                          <v-btn
                            class="btn-dateils"
                            @click="handleModalHistoryCare(item.id)"
                          >
                            <i class="fas fa-history mr-2 text-twenty"></i>
                            HISTÓRICO
                          </v-btn>

                          <div>
                            <LinkVerLocalizacaoRegistro :item="item" />
                          </div>
                        </div>

                        <div
                          :class="[
                            'col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center',
                            item.status == 'FINALIZADO',
                          ]"
                        >
                          <div class="row v-clean d-flex align-items-end">
                            <div
                              v-if="item.frequency != 'EVENTUAL'"
                              class="col-xl-4 col-lg-3 col-md-6 col-sm-6 col-6"
                            >
                              <h6 class="worksansr">HORÁRIO</h6>
                              <p
                                class="mb-0 text-for"
                                v-for="prescription_care_time in item.prescription_care_time"
                                :key="prescription_care_time.id"
                              >
                                {{
                                  prescription_care_time.time
                                    ? prescription_care_time.time
                                    : "Não informado"
                                }}
                              </p>
                            </div>

                            <div
                              class="col-md-12 d-flex justify-content-end align-items-end p-1"
                            >
                              <v-btn
                                v-if="
                                  permission(
                                    'edit',
                                    'resident_medical_prescription'
                                  ) &&
                                  item.status != 'CANCELADO' &&
                                  item.status != 'INATIVO' &&
                                  item.prescription_care_status == 'ATIVO' &&
                                  item.edited == 0
                                "
                                @click="handlePrescriptionCare(item, key_group)"
                                class="btn-edit m-1"
                              >
                                <i
                                  :class="[
                                    'fas fa-pencil-alt text-twenty',
                                    width < 600 ? 'mr-0' : 'mr-2',
                                  ]"
                                ></i>
                                <span v-if="width > 600"> EDITAR</span>
                              </v-btn>

                              <v-btn
                                v-if="
                                  permission(
                                    'edit',
                                    'resident_medical_prescription'
                                  ) &&
                                  item.status != 'CANCELADO' &&
                                  item.status != 'INATIVO' &&
                                  item.prescription_care_status == 'ATIVO' &&
                                  item.edited == 0
                                "
                                @click="
                                  handleModalDeletePrescriptionCare(
                                    item,
                                    item.id,
                                    key_group
                                  )
                                "
                                class="btn-delete m-1"
                              >
                                <i
                                  :class="[
                                    'fas fa-trash text-twenty',
                                    width < 600 ? 'mr-0' : 'mr-2',
                                  ]"
                                ></i>
                                <span v-if="width > 600"> EXCLUIR</span>
                              </v-btn>
                            </div>
                          </div>
                        </div>

                        <b-modal
                          size="lg"
                          no-close-on-backdrop
                          hide-footer
                          :id="`modalPrescriptionCare_${item.id}`"
                          title="EDITAR CUIDADO"
                        >
                          <CareViewEdit
                            :prescription_care="prescription_care"
                            :group_prescription_care="group_prescription_care"
                            v-on:update="
                              handleUpdatePrescriptionCare(item.id, key_care)
                            "
                          />
                        </b-modal>

                        <b-modal
                          size="md"
                          no-close-on-backdrop
                          hide-footer
                          :id="`modalDeletePrescriptionCare_${item.id}`"
                          title="EXCLUIR CUIDADO"
                        >
                          <CareDelete
                            :id="item.id"
                            :prescription_care="prescription_care"
                            :group_prescription_care="group_prescription_care"
                            v-on:delete="
                              handleDeletePrescriptionCare(item.id, key_care)
                            "
                          />
                        </b-modal>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <b-pagination
          align="right"
          v-if="group_prescription_cares.length > 0"
          @input="paginate()"
          v-model="page"
          :total-rows="total"
          :per-page="5"
        />
      </div>
    </b-overlay>

    <CareAdd
      :resident_id="resident_id"
      :group_prescription_care="group_prescription_care"
      @create="paginate"
    />
  </div>
</template>

<script>
import LinkVerLocalizacaoRegistro from "../../../templates/Components/LinkVerLocalizacaoRegistro";

import CareAdd from "./CareAdd";

import CareViewEdit from "../../../templates/Prescription/Care/View";

import CareDelete from "../../../templates/Prescription/Care/Delete";

import History from "../../../templates/History/Prescription";

import GeneralInformationCare from "../../../templates/Prescription/GeneralInformationCare";

import Attachments from "../../../templates/Prescription/Attachments";

import GroupCareDelete from "../../../templates/Prescription/GroupCare/Delete";

import GroupCareDuplicate from "../../../templates/Prescription/GroupCare/Duplicate";

import GroupCareView from "../../../templates/Prescription/GroupCare/View";

import GroupCareFinish from "../../../templates/Prescription/GroupCare/Finish";

import ConfirmationDialog from "../../../templates/Components/ConfirmationDialog.vue";

import { formatDate, professionalClassCouncilValue } from "../../../lib/format";

import { userData } from "../../../lib/functions";

import toast from "../../../lib/ToastNotification";

import api from "../../../services/api";

import permission from "../../../lib/permission";

import BRyHUB from "../../../lib/BRy/hub";

export default {
  name: "CareView",

  components: {
    LinkVerLocalizacaoRegistro,
    CareAdd,
    CareDelete,
    CareViewEdit,
    History,
    GeneralInformationCare,
    Attachments,
    GroupCareDelete,
    GroupCareDuplicate,
    GroupCareView,
    GroupCareFinish,
    ConfirmationDialog,
  },

  props: {
    resident_id: Number,
  },

  data() {
    return {
      loading: false,

      userIsTechnicalResponsible: false,

      panel_group_prescription_care: [],

      group_prescription_cares: [],

      group_prescription_care: {},

      prescription_care: {},

      keyGroup: 0,

      total: 0,

      page: 1,

      width: window.screen.width,

      open_history_prescription: false,

      open_history_care: false,
    };
  },

  watch: {
    async resident_id() {
      await this.paginate();
    },
  },

  created() {
    let { user } = userData();

    if (user.technical_responsible == 1) {
      this.getUserIsTechnicalResponsible();
    }
    this.paginate();
  },

  methods: {
    formatDate,
    permission,
    professionalClassCouncilValue,

    async paginate(
      keyGroup = null,
      valueGoup = 0,
      keyCare = null,
      valueCare = 0
    ) {
      try {
        this.loading = true;
        this.panel_group_prescription_care = [];
        this.panel_prescription_care = [];
        this.group_prescription_cares = [];
        this.errors = [];

        const { resident_id, status, start_date, end_date, page } = this;

        let params = {
          resident_id,
          status,
          start_date,
          end_date,
          page,
          type: "NORMAL",
        };

        const response = await api.get(
          "/rest-home/resident/group-prescription-cares",
          {
            params,
          }
        );

        const { error, errors, group_prescription_cares, total } =
          response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.isActiveFilter = false;
          this.group_prescription_cares = group_prescription_cares;

          let group_prescription_care_prints = [];
          for (let item of group_prescription_cares) {
            if (
              item.status == "FINALIZADO" &&
              item.status_prescription_care_time == "FINALIZADO"
            ) {
              group_prescription_care_prints.push({
                id: item.id,
                resident_name: item.resident_name,
                start_date: item.start_date,
                end_date: item.end_date,
              });
            }
          }

          this.group_prescription_care_prints = group_prescription_care_prints;
          this.total = total;
          if (keyGroup) {
            this.panel_group_prescription_care = [valueGoup];
            if (keyCare) {
              this.panel_prescription_care = [valueCare];
            }
          }
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async getUserIsTechnicalResponsible() {
      try {
        this.loading = true;

        const type = "PRESCRICAO";

        let params = { type };

        let response = await api.get("/technical-responsible/user", { params });

        let { userIsTechnicalResponsible } = response.data;

        this.userIsTechnicalResponsible = userIsTechnicalResponsible;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async validatePrescription(id) {
      try {
        this.loading = true;

        let params = { id, table_name: "group_prescription_care" };

        let response = await api.put("/technical-responsible", params);

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.paginate();

          await BRyHUB.authorize({ id, table: "group_prescription_care" });
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    handleClassStatusGroupPrescriptionCare(status) {
      return (
        {
          PENDENTE: "text-warning",
          CANCELADO: "text-cancel",
          FINALIZADO: "text-sucess",
          INATIVO: "text-inativi",
        }[status] || ""
      );
    },

    handleModalAddPrescriptionCare(item, key) {
      this.group_prescription_care = item;

      this.keyGroup = key;

      this.$bvModal.show("modal-add-care-add");
    },

    handleOnResize() {
      this.width = window.innerWidth;
    },

    handleDuration(duration) {
      let durations = {
        CONTINUO: "CONTÍNUO",
        DURANTE_UM_PERIODO: "DURANTE UM PERÍODO",
        ATE_A_DATA: "ATÉ A DATA",
        default: "EVENTUAL",
      };

      return durations[duration] || durations.default;
    },

    handleFrequency(frequency) {
      let frequencys = {
        DIARIO: "DIÁRIO",
        SEMANAL: "SEMANAL",
        MENSAL: "MENSAL",
        ANUAL: "ANUAL",
        EVENTUAL: "EVENTUAL",
        default: "NÃO ENCONTRADO!!!",
      };

      return frequencys[frequency] || frequencys.default;
    },

    handleEvery(every, frequency) {
      let frequencys = {
        DIARIO: "DIA",
        SEMANAL: "SEMANA",
        MENSAL: "MÊS",
        ANUAL: "ANO",
      };

      return `A CADA ${every} ${frequencys[frequency]}`;
    },

    handlePrescriptionCare(item, key) {
      this.prescription_care = item;

      this.keyGroup = key;

      this.$bvModal.show(`modalPrescriptionCare_${item.id}`);
    },

    handleModalDeletePrescriptionCare(item, id, key) {
      this.prescription_care = item;

      this.keyGroup = key;

      this.$bvModal.show(`modalDeletePrescriptionCare_${id}`);
    },

    handleDeletePrescriptionCare(id, key) {
      this.$bvModal.hide(`modalDeletePrescriptionCare_${id}`);

      this.paginate(true, this.keyGroup, true, key);
    },

    handleUpdatePrescriptionCare(id, key) {
      this.$bvModal.hide(`modalPrescriptionCare_${id}`);

      this.paginate(true, this.keyGroup, true, key);
    },

    handleModalHistoryCare(id) {
      this.$bvModal.show(`history_care_${id}`);

      setTimeout(() => (this.open_history_care = true), 200);
    },

    handleModalGeneralInformation(id) {
      this.$bvModal.show(`general_information_prescription_care${id}`);
    },

    handleModalHistoryPrescription(id) {
      this.$bvModal.show(`history_prescription_${id}`);
      setTimeout(() => (this.open_history_prescription = true), 200);
    },

    handleModalAttachmentsPrescription(id) {
      this.$bvModal.show(`attachments_prescription_${id}`);
    },

    handleModalDeleteGroupPrescriptionCare(id) {
      this.$bvModal.show(`modalDeleteGroupPrescriptionCare_${id}`);
    },

    handleDeleteGroupPrescriptionCare(id) {
      this.$bvModal.hide(`modalDeleteGroupPrescriptionCare_${id}`);

      this.paginate();
    },

    handleModalDuplicateGroupPrescriptionCare(id) {
      this.$bvModal.show(`modalDuplicateGroupPrescriptionCare_${id}`);
    },

    handleDuplicateGroupPrescriptionCare(id) {
      this.$bvModal.hide(`modalDuplicateGroupPrescriptionCare_${id}`);

      this.paginate(true, 0);
    },

    handleModalUpdateGroupPrescriptionCare(id) {
      this.$bvModal.show(`modalUpdateGroupPrescriptionCare_${id}`);
    },

    handleUpdateGroupPrescriptionCare(id, key) {
      this.$bvModal.hide(`modalUpdateGroupPrescriptionCare_${id}`);

      this.paginate(true, key);
    },

    handlePrint({ id }) {
      let route = this.$router.resolve({
        name: "group_prescription_care_print",
        params: { id },
      });

      window.open(route.href, "_blank");
    },

    handleModalFinishGroupPrescriptionCare(id) {
      this.$bvModal.show(`modalFinishGroupPrescriptionCare_${id}`);
    },

    handleFinishGroupPrescriptionCare(id) {
      this.$bvModal.hide(`modalFinishGroupPrescriptionCare_${id}`);
      this.paginate();
    },
  },
};
</script>